import { useQuery } from "react-query";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import type { Participant } from "@circle-react/types/Live/Participant";

// TODO: Implement pagination and sorting, requesting all for now
const per_page = 2000;

export const useParticipants = (roomId: string) => {
  const params = {
    per_page,
    sort: "oldest",
  };
  const { data, isLoading } = useQuery<{
    records: Participant[];
  }>(
    internalApi.liveStreams.participants({
      roomId: roomId,
      params,
    }),
  );

  const records = data?.records;
  const uniqueParticipants = records && [
    ...new Map(records.map(item => [item["email"], item])).values(),
  ];

  return {
    records: uniqueParticipants,
    isLoading,
  };
};
